module.exports = __webpack_public_path__ + "img/gallery-post.83186b1e.jpg";